import { i18n } from '@/plugins/i18n'
import TransferDescriptionColumn from "@/views/openBanking/components/manage-access/transfer-description-column.vue";
import {
    openBankingTransactionStatusBadge,
    openBankingTransactionStatusStr
} from "@/constants/openBankingTransactionStatus";
import {statementTransferTypeStr} from "@/constants/statementTransferType";
import DepositDescriptionColumn from "@/views/openBanking/components/manage-access/deposit-description-column.vue";

const descriptionTemplate = (row, index, datatable) => {
    let template = new DepositDescriptionColumn({
        props: {
            row,
            index,
            datatable,
        },
        i18n,
    })

    template.row = row
    template.index = index
    template.datatable = datatable

    return template.$mount().$el
}
export default [
    {
        field: 'id',
        title: i18n.t('label.identifier'),
        sortable: true,
        type: 'number',
        selector: false,
        textAlign: 'center'
    },

    {
        field: 'user',
        title: i18n.t('label.user_full_name'),
        sortable: false,
        textAlign: 'center',
        template: (row) => {
            return '<a href="/users/' + row.user_id + '/details">'+row.user+'</a>'
        },
    },
    {
        field: 'price',
        title: i18n.t('label.amount_rial'),
        sortable: true,
        textAlign: 'center'
    },
    {
        field: 'number',
        title: i18n.t('transaction_transfer.destination_account'),
        sortable: true,
        textAlign: 'center'
    },
    {
        field: 'type',
        title: i18n.t('label.deposit_type'),
        sortable: true,
        width: 100,
        template: (row) => {
            return `<span class="badge badge-secondary">${statementTransferTypeStr.get(row.type)}</span>`;
        },
        textAlign: 'center'
    },
    {
        field: 'status',
        title: i18n.t('label.status'),
        sortable: true,
        width: 100,
        template: (row) => {
            return `<span class="badge badge-${openBankingTransactionStatusBadge(
                row.status
            )}">${openBankingTransactionStatusStr.get(row.status)}</span>`;
        },
        textAlign: 'center'
    },
    {
        field: 'transaction_date',
        title: i18n.t('label.transaction_date'),
        sortable: false,
        textAlign: 'center'
    },
    {
        field: 'created_at',
        title: i18n.t('label.created_at'),
        sortable: true,
        textAlign: 'center'
    },
    {
        field: 'description',
        title: i18n.t('label.description'),
        template: (row, index, datatable) => {
            return descriptionTemplate(row, index, datatable)
        },
        sortable: false,
        textAlign: 'center',
    },
]